import { render, staticRenderFns } from "./AnimeView.vue?vue&type=template&id=1f893d95&"
import script from "./AnimeView.vue?vue&type=script&lang=ts&"
export * from "./AnimeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports